import { SubmitButton } from '@/components/submit-button';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useFetchRoleByIdQuery, useUpdateRoleMutation } from '@/query/role.query';

import { RoleUpdateForm } from './components/update-form';

import { RoleUpdateFormProvider } from '@/formik/role.formik';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  roleId: number;
};

export const RoleUpdate = ({ isOpen, toggle, roleId }: Props) => {
  const { data, isPending } = useFetchRoleByIdQuery(roleId, {
    enabled: isOpen,
  });

  const mutate = useUpdateRoleMutation({
    onSuccess: () => {
      toggle();
    },
  });

  return (
    <Dialog open={isOpen} onOpenChange={toggle}>
      <DialogContent className="flex flex-col max-h-[90vh] sm:max-w-2xl">
        <RoleUpdateFormProvider
          onSubmit={payload => mutate.mutate({ id: roleId, payload })}
          initialValues={data}
          className="flex flex-col flex-1 min-h-0"
        >
          <DialogHeader className="mb-4">
            <DialogTitle>Update role</DialogTitle>
          </DialogHeader>

          {/* Update Role Form */}
          <div className="overflow-y-auto flex-1 min-h-0 -mx-6 px-6">
            {isPending ? (
              <div>Loading...</div>
            ) : (
              <RoleUpdateForm selectedPermissions={data?.permissions || []} roleId={roleId} />
            )}
          </div>

          <DialogFooter className="mt-4">
            <Button type="button" variant="outline" onClick={toggle} className="flex-1">
              Cancel
            </Button>
            <SubmitButton
              isPending={mutate.isPending}
              label="Update changes"
              loadingLabel="Updating changes..."
            />
          </DialogFooter>
        </RoleUpdateFormProvider>
      </DialogContent>
    </Dialog>
  );
};
